import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { ReviewQueuePage } from "@/components/collection-apps/review/review-queue";

// Super administrador → Apps: cola de revisión de apps de colecciones.
export const Route = createFileRoute("/_super/super/apps/")({
  validateSearch: z.object({
    status: z.enum(["submitted", "approved", "rejected", "withdrawn"]).optional(),
  }),
  component: AppsReviewQueueRoute,
});

function AppsReviewQueueRoute() {
  const { status } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <ReviewQueuePage
      status={status ?? "submitted"}
      onStatus={(s) => void navigate({ search: { status: s === "submitted" ? undefined : s }, replace: true })}
    />
  );
}
